import http, { base } from '@/config/http.js'
const namespace = 'contacts'
const uri = base + '/' + namespace 

const load = () =>
	http.get(uri)
		.then(({ data }) => data.data)
		.catch(error => {
			throw Error(`Failed to GET ${namespace} - ${error}`)
		})

const create = contact => 
	http.post(uri, contact)
		.then(res => res)
		.catch(error => {
			throw Error(`Failed to POST ${namespace} - ${error}`);
		})	


const destroy = contact => 
	http.delete(`${uri}/${contact.id}`)
		.then(({data}) => data)
		.catch(error => {
			throw Error(`Failed to DELETE ${namespace} - ${error}`);
		})

const test = contact => http.post(`${uri}/test-email`)

export default {
	contactsLoad: load,
	contactsCreate: create,
	contactsDestroy: destroy,
	contactsTestEmail: test
}
